module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: entry.sys.contentType && entry.sys.contentType.sys.id,

      name: entry.fields.name ? entry.fields.name['nb-NO'] : '',
      type: entry.fields.type ? entry.fields.type['nb-NO'] : null,
      items: entry.fields.schemaStructure ? entry.fields.schemaStructure['nb-NO'] : []
    };

    return result;
  },

  internalToContentful(schema) {
    const result = {
      fields: {
        name: {
          'nb-NO': schema.name
        },
        type: {
          'nb-NO': schema.type
        },
        schemaStructure: {
          'nb-NO': schema.items
        }
      },
      overwriteKeys: ['schemaStructure']
    };

    return result;
  }
};
